export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.25 20.25C5.25 16.9363 7.93627 14.25 11.25 14.25H24.75C28.0637 14.25 30.75 16.9363 30.75 20.25V26.25C30.75 27.9068 29.4068 29.25 27.75 29.25H8.25C6.59314 29.25 5.25 27.9068 5.25 26.25V20.25Z"
                stroke="#3EAE60"
                strokeWidth="1.69"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.5002 14.25V9C29.25 9 29.25 3.75 25.5002 3.75C21.7503 3.75 14.2503 3.75 10.5002 3.75C6.75005 3.75 6.74985 9 10.5002 9V14.25"
                stroke="#3EAE60"
                strokeWidth="1.69"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16.5 8.25L15 9.75" stroke="#3EAE60" strokeWidth="1.69" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21 8.25L19.5 9.75" stroke="#3EAE60" strokeWidth="1.69" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18 24.75C19.6569 24.75 21 23.4069 21 21.75C21 20.0931 19.6569 18.75 18 18.75C16.3431 18.75 15 20.0931 15 21.75C15 23.4069 16.3431 24.75 18 24.75Z"
                stroke="#3EAE60"
                strokeWidth="1.69"
            />
            <path d="M11.25 29.25V32.25" stroke="#3EAE60" strokeWidth="1.69" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M24.75 29.25V32.25" stroke="#3EAE60" strokeWidth="1.69" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
